/**
 * True when the current pathname matches any of the close-on-navigation paths.
 * Pure predicate shared by the sidebar wrappers so each wrapper supplies its
 * own path list while the matching logic stays in one place.
 */
export const shouldCloseSidebar = (
  pathname: string,
  paths: string[]
): boolean => paths.some((path) => pathname.includes(path));

/**
 * True when navigation has just LEFT any of the given paths — the previous
 * pathname matched one and the current does not.
 *
 * What the org sidebar uses to know its frameworks-in-use list may be stale:
 * project set-up is where a framework gets adopted or removed, the wrapper
 * stays mounted across that whole SPA journey, and a list fetched once on
 * mount would otherwise only catch up on a full page refresh.
 */
export const hasLeftPaths = (
  previousPathname: string,
  pathname: string,
  paths: string[]
): boolean =>
  shouldCloseSidebar(previousPathname, paths) &&
  !shouldCloseSidebar(pathname, paths);
